export default __webpack_public_path__ + "files/e5d499fe2c0f954e6af77afd70c4e376.mp3";